;(function () {

"use strict";

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init object list view');
  }
});

module.exports = PageView;

}());